module.exports = __webpack_public_path__ + "img/mobhome.c79026c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobhome.png
// module id = C+sg
// module chunks = 83